import { fetchMethod, postMethod, putMethod } from "./http.api";

const CarCommonService = {

    getCar: async (id: string) => {
        return fetchMethod(`/v1/CorrectiveActionRequest/car/${id}`)
    },

    getProjects: async () => {
        return fetchMethod(`/v1/CustomerDashboard`)
    },

    updateCAR: async (id: string, data: object) => {
        return putMethod(`/v1/CorrectiveActionRequest/${id}`, data)
    },
};

export default CarCommonService;